import { io } from 'socket.io-client';

import socketBaseUrl from './socketBaseUrl';

const socketShipStationTagger = io(`${socketBaseUrl}/ship-station-tagger-progress`, {
  transports: ['websocket'],
  autoConnect: false,
});

export default socketShipStationTagger;
